export default {
  page_header: {
    title: "About",
    description: "On this page you can find information about the Iris system and its components.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Overview",
      title: "Welcome to Iris",
      subtitle: "Laboratory connectivity and sample management system.",
      version_label: "Application version",
      version_tooltip: "Current deployed version of Iris UI",
      description:
        "Iris is a web-based laboratory connectivity platform that bridges clinical analyzers with Laboratory Information Systems (LIS). It manages instrument channels, processes result data, and routes samples through a validation workflow before publication.",

      metadata: {
        publisher: "Publisher",
        publisher_tooltip: "Software vendor responsible for Iris",
        license: "License",
        license_tooltip: "Distribution terms for this application",
        license_value: "Proprietary",
        stack: "Stack",
        stack_tooltip: "Core frontend technologies powering Iris",
        stack_value: "Vue 3 / Nuxt 4 / Vuetify 3",
        publisher_value: "SKYWARE Group",
      },

      features: {
        header: "Key Features:",

        sample_management: {
          title: "Sample Management",
          subtitle: "Route instrument results through a configurable validation queue before publishing to LIS",
        },
        real_time_results: {
          title: "Real-Time Results",
          subtitle: "Receive and display instrument data over TCP channels as results arrive",
        },
        multilingual_support: {
          title: "Multilingual Support",
          subtitle: "Switch between English, Bulgarian, and Macedonian from any page",
        },
        secure_authentication: {
          title: "Secure Authentication",
          subtitle: "Role-based access control via OIDC / Keycloak",
        },
        responsive_design: {
          title: "Responsive Design",
          subtitle: "Optimised for desktop, tablet, and mobile browsers",
        },
        accessibility: {
          title: "Accessibility",
          subtitle: "Designed to meet WCAG 2.1 AA accessibility standards",
        },
        high_performance: {
          title: "High Performance",
          subtitle: "Reactive UI built for time-sensitive lab workflows",
        },
      },

      targetUsers: {
        header: "Who Iris is for:",

        lab_technicians: {
          title: "Lab Technicians",
          subtitle:
            "Receive instrument results, review pending samples, and approve or reject before publishing to LIS",
        },
        pathologists: {
          title: "Pathologists and Specialists",
          subtitle: "Review and validate sample results across connected instruments",
        },
        lab_administrators: {
          title: "Lab Administrators",
          subtitle: "Configure instruments, channels, and panels, and monitor system health",
        },
      },
    },

    services_tab: {
      name: "Services",
      title: "System Services",
      subtitle: "Version and health status for each Iris service",

      refresh_button: "Refresh Services",
      refresh_service: "Refresh",

      fe_description:
        "The web frontend. Provides the user interface for managing instruments, channels, and sample validation workflows.",
      core_description:
        "The central backend service. Manages instruments, channels, tests, and the sample validation queue. Exposes a REST API consumed by Iris UI.",
      adapter_description:
        "The LIS integration service. Retrieves patient and order data from the LIS, and publishes validated sample results back to the LIS.",
    },

    actions_tab: {
      name: "Actions",
      title: "System Actions",
      subtitle: "Manage system cache and configuration",

      cache_card: {
        title: "Refresh Iris Core Cache",
        content:
          "Clears the Iris Core in-memory cache and forces the next request to reload all instruments, channels, and configuration data from the database. Use this to resolve stale data after direct database changes.",
        action: "Refresh Cache",
      },
    },

    copyright_tab: {
      name: "Copyright",
      title: "Copyright",
      subtitle: "Intellectual property and licenses",

      description_start: "All intellectual property of this application belongs to ",
      description_end:
        ". The rights to the components and libraries used in this application belong to their authors and are appropriately licensed as described below.",

      authors_label: "Authors of this application",
      authors_value: "Mikhail Kalatchev, Ivan Kalatchev",
      developed_by: "Developed by",
      third_party_header: "Third-party licenses",
      col_component: "Component",
      col_license: "License",
      col_author: "Author",
    },

    credits_tab: {
      name: "Credits",
      title: "Credits",
      subtitle: "Built with open-source technologies",

      application_title: "Iris UI",
      authors_of_application: "Authors of this application",
      licence: "license",
      et_al: "et al",
    },
  },
};
